import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { Pricing } from "../components/Pricing";
import { QuoteSimulator } from "../components/QuoteSimulator";
import { ContactForm } from "../components/ContactForm";

export default function Landing() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <Pricing />
        <QuoteSimulator />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
